module.exports = "<app-navbar></app-navbar>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /Users/sachinmacbook/Sites/ngfront/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main